
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.672 12.464l-.09-.178c-.253-.587-3.359-1.477-3.612-1.495l-.198.018c-.38.071-.795.41-1.607 1.103a.496.496 0 01-.578.071C7.52 11.396 6.22 10.222 5.57 9.51c-.704-.765-1.553-2.028-1.95-3.042a.527.527 0 01.145-.552c.92-.818 1.318-1.21 1.354-1.637.018-.249-.524-3.398-1.084-3.7L3.874.471C3.513.24 2.97-.098 2.375.027a1.671 1.671 0 00-.415.16C1.563.436.57 1.112.118 1.984c-.27.551-.397 5.551 3.395 9.768 3.756 4.181 8.396 4.36 9.082 4.217h.018l.055-.018c.939-.338 1.733-1.21 2.04-1.584.56-.658.18-1.459-.036-1.903z","fill":"currentColor"}})])
          )
        }
      }
    